module.exports = __webpack_public_path__ + "facebook-icon.jpg?648465537566fb7f81e2bf6f127d7be7";


//////////////////
// WEBPACK FOOTER
// ./src/images/facebook-icon.jpg
// module id = 57
// module chunks = 0